import * as Yup from "yup";

export const UsuarioSchema = Yup.object().shape({
  nombre: Yup.string().required("Por favor ingrese el campo nombre"),
  apellido: Yup.string().required("Por favor ingrese el campo apellido"),
  rol: Yup.string().required("Por favor seleccione el rol"),
  email: Yup.string()
    .email("Por favor ingrese un email válido")
    .required("Por favor ingrese un email")
    .max(100, "El campo Email puede tener hasta 100 caracteres"),
  password: Yup.string()
    .required("Por favor ingrese una contraseña válida")
    .min(10, "La contraseña debe tener al menos 10 caracteres")
    .max(20, "La contraseña no debe exceder los 20 caracteres")
    .test(
      "lowercase-test",
      "La contraseña debe contener al menos 2 letras minúsculas",
      value => /(?=(.*[a-zñüáéíóú]){2,})/.test(value)
    )
    .test(
      "uppercase-test",
      "La contraseña debe contener al menos 2 letras mayúsculas",
      value => /(?=(.*[A-ZÑÜÁÉÍÓÚ]){2,})/.test(value)
    )
    .test(
      "number-test",
      "La contraseña debe contener al menos 2 números",
      value => /(?=(.*\d){2,})/.test(value)
    )
    .test(
      "special-character-test",
      "La contraseña debe contener al menos 2 caracteres especiales",
      value => /(?=(.*[@$!%*?&'`.]){2,})/.test(value)
    ),
  repetirPassword: Yup.string().when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf(
      [Yup.ref("password")],
      "Ambas contraseñas deben coincidir"
    ),
  }),
});

export const UsuarioDataSchema = Yup.object().shape({
  nombre: Yup.string().required("Por favor ingrese el campo nombre"),
  apellido: Yup.string().required("Por favor ingrese el campo apellido"),
  rol: Yup.string().required("Por favor seleccione el rol"),
  email: Yup.string()
    .email("Por favor ingrese un email válido")
    .required("Por favor ingrese un email")
    .max(100, "El campo Email puede tener hasta 100 caracteres"),
});

export const CredencialesSchema = Yup.object().shape({
  user: Yup.string().required("Por favor ingrese el campo usuario"),
  pass: Yup.string().required("Por favor ingrese el campo password"),
  // prefijo: Yup.string().required("Por favor ingrese un número válido"),
});



export const CambiarPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Por favor ingrese una contraseña válida")
    .min(10, "La contraseña debe tener al menos 10 caracteres")
    .max(20, "La contraseña no debe exceder los 20 caracteres")
    .test(
      "lowercase-test",
      "La contraseña debe contener al menos 2 letras minúsculas",
      value => /(?=(.*[a-zñüáéíóú]){2,})/.test(value)
    )
    .test(
      "uppercase-test",
      "La contraseña debe contener al menos 2 letras mayúsculas",
      value => /(?=(.*[A-ZÑÜÁÉÍÓÚ]){2,})/.test(value)
    )
    .test(
      "number-test",
      "La contraseña debe contener al menos 2 números",
      value => /(?=(.*\d){2,})/.test(value)
    )
    .test(
      "special-character-test",
      "La contraseña debe contener al menos 2 caracteres especiales",
      value => /(?=(.*[@$!%*?&'`.]){2,})/.test(value)
    ),
  
  repetirPassword: Yup.string().when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf(
      [Yup.ref("password")],
      "Ambas contraseñas deben coincidir"
    ),
  }),
});

export const ClientSchema = Yup.object().shape({
  appName: Yup.string().required("Por favor ingrese el campo nombre"),
  appUser: Yup.string().required("Por favor ingrese el nombre de usuario. Debe ser único."),
  appUrl: Yup.string().required("Por favor ingrese el campo appUrl"),
  email: Yup.string()
    .email("Por favor ingrese un email válido")
    .required("Por favor ingrese un email")
    .max(100, "El campo Email puede tener hasta 100 caracteres"),
  razonSocial: Yup.string().required("Por favor ingrese el campo razón social"),
  personaFisica: Yup.boolean(),
  nroDoc: Yup.string().required(
    "Por favor ingrese el campo número de documento"
  ),
  cuit: Yup.string()
    .required("Por favor ingrese el campo CUIT")
    .matches(/^[0-9]+$/, "El CUIT debe contener solo números"),
  aceptaTerminos: Yup.boolean()
    .required(
      "Para el alta del cliente de aplicación deben aceptarse los términos y condiciones"
    )
    .oneOf(
      [true],
      "Para el alta del cliente de aplicación deben aceptarse los términos y condiciones"
    ),
});

export const DoctorNewPassSchema = Yup.object().shape({
  currentPassword: Yup.string().required("El campo es requerido"),
  newPassword: Yup.string()
    .required("Por favor ingrese una contraseña válida")
    .min(10, "La contraseña debe tener al menos 10 caracteres")
    .max(20, "La contraseña no debe exceder los 20 caracteres")
    .test(
      "lowercase-test",
      "La contraseña debe contener al menos 2 letras minúsculas",
      value => /(?=(.*[a-zñüáéíóú]){2,})/.test(value)
    )
    .test(
      "uppercase-test",
      "La contraseña debe contener al menos 2 letras mayúsculas",
      value => /(?=(.*[A-ZÑÜÁÉÍÓÚ]){2,})/.test(value)
    )
    .test(
      "number-test",
      "La contraseña debe contener al menos 2 números",
      value => /(?=(.*\d){2,})/.test(value)
    )
    .test(
      "special-character-test",
      "La contraseña debe contener al menos 2 caracteres especiales",
      value => /(?=(.*[@$!%*?&'`.]){2,})/.test(value)
    ),
  rePassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Las contraseñas deben coincidir")
        .required("Confirme su nueva contraseña"),
});


export const DoctorMyInfoSchema = Yup.object({
  name: Yup.string().required("El campo es requerido").max(50, "Máximo 50 caracteres"),
  lastname: Yup.string().required("El campo es requerido").max(50, "Máximo 50 caracteres"),
  specialty: Yup.string().max(45, "Máximo 45 caracteres"),
  birthdate: Yup.date(),
  sex: Yup.string().required("El campo es requerido"),
  phone: Yup.number()
        .typeError('El campo télefono debe ser numérico')
        .required(
    "El campo télefono es requerido"
  ),
  address: Yup.string().max(500, "Máximo 500 caracteres"),
  mensaje: Yup.string()
});